import {
  Menu as ChakraMenu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from "@chakra-ui/react"
import { IMenuItemsProps, IMenuProps } from "./MenuTypes"
import { StyledMenuItem } from "./StyledMenu"

const Menu: React.FC<IMenuProps> = ({
  menuItems,
  menuTitle,
  menuIteHeight,
}) => {
  return (
    <ChakraMenu>
      <MenuButton>{menuTitle}</MenuButton>
      <MenuList
        border="none"
        borderRadius="base"
        boxShadow="primary"
        padding={0}
        width="200px"
      >
        <StyledMenuItem boxShadow={"primary"} padding={"unset"} zIndex={5}>
          {menuItems.map((item: IMenuItemsProps) => (
            <MenuItem
              height={menuIteHeight}
              key={item.id}
              fontWeight="bold"
              _hover={{ bg: "transparent" }}
              onClick={item.onClick}
            >
              {item.text}
            </MenuItem>
          ))}
        </StyledMenuItem>
      </MenuList>
    </ChakraMenu>
  )
}

export default Menu
